import {EnumTipoTchFij} from './enum/enum-costos-horarios';

export class ClsCatalogoCostosCalculo {
  IdCatalogo?: bigint; // se ocupa para la repuesta al abrir el ppto, JSON del storage
  Costo93Moneda1: number; // total de MO gravable(sin salario integrado) esta matriz(sin incluir basicos)
  Costo94Moneda1: number; // total de MAT esta matriz(sin incluir basicos)
  Costo95Moneda1: number; // total de MAT esta matriz incluyendo basicos
  Costo96Moneda1: number; // total de MO esta matriz(sin incluir basicos)
  Costo97Moneda1: number; // total de MO gravable esta matriz(incluyendo basicos)
  Costo98Moneda1: number; // total de MO esta matriz(incluyendo basicos)
  Costo93Moneda2: number;
  Costo94Moneda2: number;
  Costo95Moneda2: number;
  Costo96Moneda2: number;
  Costo97Moneda2: number;
  Costo98Moneda2: number;
  Costo93Moneda3: number;
  Costo94Moneda3: number;
  Costo95Moneda3: number;
  Costo96Moneda3: number;
  Costo97Moneda3: number;
  Costo98Moneda3: number;
}

export class ClsCatalogoCostosOPCalculo {
  IdCatalogo?: bigint; // se ocupa para la repuesta al abrir el ppto, JSON del storage
  AlmacenajeMoneda1: number;
  CostoLABMoneda1: number;
  DerechosMoneda1: number;
  FletesMoneda1: number;
  ManiobraMoneda1: number;
  MermasMoneda1: number;
  AlmacenajeMoneda2: number;
  CostoLABMoneda2: number;
  DerechosMoneda2: number;
  FletesMoneda2: number;
  ManiobraMoneda2: number;
  MermasMoneda2: number;
  AlmacenajeMoneda3: number;
  CostoLABMoneda3: number;
  DerechosMoneda3: number;
  FletesMoneda3: number;
  ManiobraMoneda3: number;
  MermasMoneda3: number;
}

export class ClsCatalogoMOCalculo {
  IdCatalogo?: bigint; // se ocupa para la repuesta al abrir el ppto, JSON del storage
  SalarioBaseMoneda1: number;
  FactorSalarioIntegradoMoneda1: number;
  FasarMoneda1: number;
  SalarioIntegradoMoneda1: number;
  SalarioRealMoneda1: number;
  ViaticosMoneda1: number;
  AlimentacionYHospedajeMoneda1: number;
  GastosDeSepelioMoneda1: number;
  OtrasPrestacionesMoneda1: number;
  RiesgosdeTrabajoMoneda1: number;
  TipoFasarMoneda1: number;
  CostoTotalMoneda1?: number; // solo se ocupa para validar si cambio al momento de calcular el ppto
  SalarioBaseMoneda2: number;
  FactorSalarioIntegradoMoneda2: number;
  FasarMoneda2: number;
  SalarioIntegradoMoneda2: number;
  SalarioRealMoneda2: number;
  ViaticosMoneda2: number;
  AlimentacionYHospedajeMoneda2: number;
  GastosDeSepelioMoneda2: number;
  OtrasPrestacionesMoneda2: number;
  RiesgosdeTrabajoMoneda2: number;
  TipoFasarMoneda2: number;
  CostoTotalMoneda2?: number; // solo se ocupa para validar si cambio al momento de calcular el ppto
  SalarioBaseMoneda3: number;
  FactorSalarioIntegradoMoneda3: number;
  FasarMoneda3: number;
  SalarioIntegradoMoneda3: number;
  SalarioRealMoneda3: number;
  ViaticosMoneda3: number;
  AlimentacionYHospedajeMoneda3: number;
  GastosDeSepelioMoneda3: number;
  OtrasPrestacionesMoneda3: number;
  RiesgosdeTrabajoMoneda3: number;
  TipoFasarMoneda3: number;
  CostoTotalMoneda3?: number; // solo se ocupa para validar si cambio al momento de calcular el ppto
}

export class ClsCatalogoCalculo {
  IdCatalogo: bigint;
  Codigo?: string; // solo se ocupa para guardar datos desde la ventana de FASAR
  CostoTotal?: number; // solo se ocupa para guardar datos desde la ventana de FASAR
  JsonCatalogoCostosCalculo: string;
  CatalogoCostosCalculo: ClsCatalogoCostosCalculo[];
  JsonCatalogoCostosOP: string;
  CatalogoCostosOP: ClsCatalogoCostosOPCalculo[];
  JsonCatalogoMO: string;
  CatalogoMO: ClsCatalogoMOCalculo[];
}

export class ClsCalculoCatalogo extends ClsCatalogoCostosCalculo {
  // IdCatalogo?: bigint;
  Calculado: boolean;
  CostoMoneda1: number;
  CostoMoneda2: number;
  CostoMoneda3: number;
  EsPorcentaje: boolean;
  TipoPorcentaje: number;
  TipoInsumo: number;
  InsumoIntegrado: boolean;
  Nivel: number;
  Expins: number;
  Expinsl?: boolean;
  // Costo horario
  TchFij: EnumTipoTchFij;
}

export class ClsCalculoMatriz {
  IdCodigoInsumo: bigint;
  Dividir: boolean;
  Volumen: number;
  // son campos nuevos, se agrego cuando solicitaron poder editar el renglon ya que era la llave y expresion
  Control?: number;
  Expresion?: string;
  Renglon?: number;
  // sirve para los errores potenciales
  CodigoMatriz?: string;
  CodigoInsumo?: string;
  Descripcion?: string;
  DescripcionLarga?: string;
  Tipo?: number;
  EsPorcentaje?: number;
  Unidad?: string;
}

export class ClsCalculoOrderNivel {
  IdCatalogo: bigint;
  Nivel: number;
}

export class ClsCalculoPartidas {
  IdPartidaPadre: bigint;
  IdPresupuestoPartida?: bigint;
  Costo1?: number;
  Precio1?: number;
  Costo2?: number;
  Precio2?: number;
  Renglon?: number;
  WBS?: string;
}

export class ClsCalculoPresupuesto {
  IdCatalogo: bigint;
  Cantidad: number;
}

export class ClsCalculoGuardarCatalogo {
  IdCatalogo: bigint;
  Nivel: number;
  CostoMoneda1: number;
  CostoMoneda2: number;
  Expins: number;
  Expinsl: boolean;
}

export class ClsCalculoGuardarPartidas {
  IdPresupuestoPartida: bigint;
  CostoMoneda1: number;
  PrecioMoneda1: number;
  CostoMoneda2: number;
  PrecioMoneda2: number;
  JsonConceptos: ClsConceptosPartidasGuardar[];
}

export class ClsConceptosPartidasGuardar {
  IdCatalogo: bigint;
  PrecioMoneda1: number;
  PrecioMoneda2: number;
  Control: number;
}

export class ClsCalculoDetalleExpXConcepto {
  IdCatalogo: bigint;
  Expins: number;
}

export class ClsCalculoDetalleExpXConceptoProyecto {
  IdCodigoMatriz: bigint;
  JsonExpinsXconcepto: ClsCalculoDetalleExpXConcepto[];
}

export class ClsWBSRenglon {
  IdPresupuestoPartida: bigint;
  Renglon?: number;
  PartidaWBS?: string;
}

export class ClsColumnasErroresPotenciales {
  Partida?: string;
  Renglon?: string;
  Codigo?: string;
  Codigo2?: string;
  Descripcion?: string;
  DescripcionLarga?: string;
  Tipo?: string;
  Unidad?: string;
  EsPorcentaje?: string;
  Fecha?: string;
  Costo?: string;
  PorcentajeIndEsp?: string;
}
